import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'
import { useParams } from 'react-router-dom'
import { useProductAllocation } from './Allocations.data'
import { AllocationsTable } from './Allocations.table'

export const AllocationsView = () => {
  const { projectId, scenarioId } = useParams()
  const { data, isLoading } = useProductAllocation({
    projectId: projectId ?? '',
    scenarioId: scenarioId ?? '',
  })
  return (
    <SettingsPage title="Allocations">
      <AllocationsTable
        data={data?.data ?? []}
        isLoading={isLoading}
        projectId={projectId ?? ''}
        scenarioId={scenarioId ?? ''}
        baskets={data?.baskets ?? []}
      />
    </SettingsPage>
  )
}
